<template>
  <div>
    <el-popover
      v-model="visible"
      placement="top"
      width="350"
      trigger="manual"
    >
      <span style="color: #F67C7C"> <svg-icon icon-class="tip-fill" style="margin-right: 5px;" />{{ $t('tips.add_up_six_account') }}</span>
      <el-button slot="reference" type="primary" icon="el-icon-plus" :disabled="bankAccountList.length>=6" class="add-btn" @click="onClickAddBtn">{{ $t('data.add_new_bank_account') }}</el-button>

    </el-popover>
    <div class="bank-box">
      <!--        银行账户列表-->
      <div v-for="(item, index) in bankAccountList" :key="index" class="bank-item">
        <div class="bank-head" :class="{[aduitStatus[item.audit_status]]: true}">
          <span>
            {{ item.audit_status === 1 ? $t('system.reviewing') : ( item.audit_status === 2 ? $t('system.activated'): $t('system.reject')) }}
          </span>
        </div>
        <div class="content">
          <div class="content-item " style="margin-bottom: 10px;">
            <span class="name">{{ $t('data.currency') }}:</span>
            <span class="value"> <el-tag :type="item.settlement_type === SETTLEMENT_TYPE['usd'] ? 'success' : 'primary' "> {{ showCurrency(item) }}</el-tag></span>
          </div>
          <div class="content-item mb-16">
            <span class="name">{{ $t('merchant.account_bank') }}:</span>
            <span class="value">{{ item.settlement_bank }}</span>
          </div>
          <div class="content-item mb-16">
            <span class="name">{{ $t('merchant.account_name') }}:</span>
            <span class="value">{{ item.settlement_bank_account_name }}</span>
          </div>
          <div class="content-item" style="padding-right: 80px;">
            <span class="name">{{ $t('merchant.account_num') }}:</span>
            <span class="value">{{ item.settlement_bank_account_num }}</span>
          </div>
          <el-button size="mini" style="padding-left: 10px;padding-right: 10px" type="danger" plain class="btn-bank-delete" @click="clickDelete(item)">
            <svg-icon icon-class="delete" />   {{ $t('components.delete') }}
          </el-button>
        </div>

      </div>

    </div>
    <!--        添加银行账户弹窗-->
    <AddBankAccountModal ref="addBankAccountModal" @submit="getBankAccountList" />
    <!--        删除银行账户-->
    <DeleteBankAccountModal ref="deleteBankAccountModal" @submit="getBankAccountList" />
  </div>
</template>

<script>

import { GetMoreBankList } from '@/api/data/data'
import { generateTitle } from '@/utils/i18n'
export default {
  name: 'Bank-Account-List', // 银行账户列表页
  components: {
    AddBankAccountModal: () => import('./Modal/AddBankAccountModal.vue'),
    DeleteBankAccountModal: () => import('./Modal/DeleteBankAccountModal.vue')
  },
  data() {
    this.SETTLEMENT_TYPE = {
      local: 1,
      usd: 2
    }
    this.aduitStatus = {
      1: 'pending',
      2: 'success',
      3: 'warning'
    }
    return {
      visible: false,
      bankAccountList: [],
      pageLoading: false
    }
  },
  computed: {
    showCurrency() {
      return function(item) {
        if (item.settlement_type === this.SETTLEMENT_TYPE['usd']) {
          return 'USD'
        } else {
          return this.$store.getters.findOnlineCountryObj(item.settlement_country).currency
        }
      }
    }
  },
  watch: {
    bankAccountList() {
      if (this.bankAccountList.length >= 6) {
        this.visible = true
      } else {
        this.visible = false
      }
    }
  },
  created() {
    this.getBankAccountList()
  },
  mounted() {

  },

  methods: {
    generateTitle,
    onClickAddBtn() {
      if (this.bankAccountList.length === 6) {
        return this.$message.warning('You can only add up to six accounts.')
      }
      this.$refs.addBankAccountModal.changeModalStatus(true)
    },
    clickDelete(item) {
      if (this.bankAccountList.length <= 1) return this.$message.warning(this.$t('tips.delete_last_bank'))
      if (item.auto_status === 1) return this.$message.warning(this.$t('tips.delete_auto_withdrawal_bank'))
      this.$refs.deleteBankAccountModal.showModal(item)
    },
    getBankAccountList() {
      this.pageLoading = true
      GetMoreBankList().then(res => {
        this.bankAccountList = res.data || []
      }).finally(() => {
        this.pageLoading = false
      })
    }
  }
}
</script>

  <style scoped lang="scss">
  .add-btn {
    position: absolute;
    top: 69px;
    right:  24px;
  }
    .bank-box {
      margin-top: 48px;
      display: grid;
      // justify-content: space-between;
      align-items: center;
      gap: 20px;
      grid-template-columns: repeat(auto-fill, 410px);
      font-size: 14px;
      .bank-item {
        position: relative;
        background: #FFFFFF;
        border: 1px solid rgba(54, 66, 80, 0.20);
        border-radius: 8px;
        padding: 24px;
        .bank-head {
          position: absolute;
          top: 24px;
          right: 24px;
          padding: 8px;
          border-radius: 2px;
          font-size: 12px;

          &.pending {
            background: #FDE68A;
            color: #B45309;
          }
          &.success {
            color: #047857;
            background: #A7F3D0;
          }
          &.warning{
            background-color: #FFE1C4;
            color: #EE7700;
          }
        }
        .content {
          &-item {
            line-height: 1;
            overflow: hidden; /* 隐藏溢出部分 */
            text-overflow: ellipsis; /* 在文本末尾添加省略号 */
            .name {
              color: #364250;
              font-size: 14px;
              font-weight: bold;
              white-space: nowrap; /* 禁止文本换行 */
              margin-right: 12px;
            }
            .value {
              color: #364250;
              font-size: 14px;
              font-weight: 400;
              white-space: nowrap; /* 禁止文本换行 */
            }
          }
        }
        .btn-bank-delete{
          position: absolute;
          bottom: 24px;
          right: 24px;
        }
      }
    }
  </style>
